import { render, staticRenderFns } from "./home-menu.vue?vue&type=template&id=76848730&scoped=true"
import script from "./home-menu.vue?vue&type=script&lang=js"
export * from "./home-menu.vue?vue&type=script&lang=js"
import style0 from "./home-menu.vue?vue&type=style&index=0&id=76848730&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76848730",
  null
  
)

export default component.exports